import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { HistoricalPointInTimeBase } from "abweb/dto/generated/ds/HistoricalPointInTimeBase";
import { DateTimeUtils } from "abweb/utils/date/DateTimeUtils";
export class HistoricalPointInTime extends HistoricalPointInTimeBase {
  static createEmptyHistoricalPointInTime() {
    return HistoricalPointInTime.createHistoricalPointInTime(null, null);
  }
  static createHistoricalPointInTime(datetime, version) {
    const retVal = new HistoricalPointInTime();
    retVal.initHistoricalPointInTime(/*active*/true, datetime, version);
    return retVal;
  }
  constructor() {
    super();
    // Set this to false if the contained datetime value really represents a date.
    _defineProperty(this, "_isDateTime", true);
  }
  get isDateTime() {
    return this._isDateTime;
  }
  set isDateTime(value) {
    this._isDateTime = value;
  }

  // An 'empty' historical point in time is used to indicate that requests are not made in a historical context.
  get isEmpty() {
    return this.datetime == null && this.version == null;
  }
  get displayValue() {
    return this.datetime ? DateTimeUtils.DATE_SHORT.format(this.datetime) : null;
  }
}
//# sourceMappingURL=HistoricalPointInTime.js.map
